var _ellipse, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeogebra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 290,
    height: 290,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "loop",
    stroke: "#666",
    strokeWidth: 20,
    fill: "none",
    cx: 148,
    cy: 147,
    rx: 99,
    ry: 122,
    transform: "rotate(60 148 147)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circles",
    fill: "#99f",
    stroke: "#000",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 46,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 88,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 211,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 246,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 144,
    r: 22
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeogebra);
export default __webpack_public_path__ + "static/media/Geogebra.33feda3d675a15d7a67bf859ef048dc3.svg";
export { ForwardRef as ReactComponent };